module.exports = __webpack_public_path__ + "img/blog-12.5b207c17.jpg";